// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"312":"b5cfb81116a5cc24","888":"af6d392725d33106"}[chunkId] + ".css";
};